export const QUIZ = 'quiz'
export const ROOM_STATE = 'room_state'
export const SCREEN_SHARE = 'screen_share'
export const IFRAME = 'iframe'
export const VIDEO_CALL = 'video_call'
export const WHITEBOARD = 'whiteboard'

export const CLASSROOM = 'class_room'
export const SECONDARY_DEVICE = 'secondary_device'
export const RECONNECTING = 'reconnecting'
